import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import styled from 'styled-components';

import { useAppSelector } from 'store/hook';

import CompetitorInfoCompetitorMenuItem from './CompetitorInfoCompetitorMenuItem';
import { CommunityType } from '../../types/communities';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-top: 1px solid var(--line-gray);
`;

interface Props {
  competitors: CommunityType[];
}

const CommunityInfoCompetitorMenu = ({ competitors }: Props) => {
  const navigate = useNavigate();
  const { selectedCommunity } = useAppSelector((state) => state.global);

  const isBasePath = location.pathname === `/community/${selectedCommunity?.id}/competitor`;

  useEffect(() => {
    if (isBasePath && competitors?.length) {
      const firstCompetitor = competitors[0];
      navigate(`/community/${selectedCommunity?.id}/competitor/${firstCompetitor?.id}/info`);
    }
  }, [competitors, selectedCommunity?.id, navigate]);

  return (
    <Container data-test-id="cd-community-info-competitor-menu">
      {competitors.map((item) => (
        <CompetitorInfoCompetitorMenuItem
          key={item.id}
          to={`/community/${selectedCommunity?.id}/competitor/${item.id}/info`}
          competitorId={item.id}
          label={item.comunity_name}
          description={item.address}
        />
      ))}
    </Container>
  );
};

export default CommunityInfoCompetitorMenu;
